import { defineStore } from 'pinia'

export const useBulletScreenStore = defineStore('bulletScreen', {
  state: () => ({
    bulletScreenList: [],
    currentRow: 0
  }),

  actions:{
    addBulletScreen(text){
      const rowHeight = 40
      const rowCount = 4
      const top = this.currentRow * rowHeight + 10
      const duration = 4
      const id = Date.now() + Math.random()
      this.bulletScreenList.push({
        text,
        top,
        duration,
        id
      })
      this.currentRow = (this.currentRow + 1) % rowCount
    },
    
    removeBulletScreen(id){
      // 延迟一小段时间再移除，确保动画最后一帧已渲染
      setTimeout(() => {
        const index = this.bulletScreenList.findIndex(item => item.id === id)
        if (index !== -1) {
          this.bulletScreenList.splice(index, 1)
        }
      }, 50)
    }
  },

  
})